import api from '../utils/api';

// Integração com a API Maestro (Vivo) através do vision_be.
// O número do TA (idBoleto) e o carimbo são resolvidos no backend a partir da
// própria Request — aqui só passamos qual chamado tramitar.

export const tramitar = async (requestId) => {
    const token = localStorage.getItem('token');
    api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;

    const { data } = await api.post(`/maestro/tramitar/${requestId}`);
    return data;
};

const MaestroService = {
    tramitar,
};

export default MaestroService;
